// components/Impact.js (Updated with images)
import React from 'react';
import './Impact.css';
import { images } from '../utils/images';

const Impact = () => {
  const testimonials = [
    {
      name: "Priya Sharma",
      role: "Education Program Beneficiary",
      image: images.impact.testimonial1,
      quote: "Pragathi NGO changed my life. Through their education program, I was able to complete my studies and now I'm a teacher helping other children in my community."
    },
    {
      name: "Rajesh Kumar",
      role: "Healthcare Program Beneficiary",
      image: images.impact.testimonial2,
      quote: "The free medical camps organized by Pragathi NGO saved my father's life. Their healthcare initiatives have been a blessing for our village."
    },
    {
      name: "Anita Devi",
      role: "Women Empowerment Program",
      image: images.impact.testimonial3,
      quote: "The skill training I received helped me start my own tailoring business. Now I'm financially independent and supporting my family."
    }
  ];

  return (
    <section id="impact" className="impact">
      <div className="container">
        <h2 className="section-title">Our Impact</h2>
        
        <div className="impact-numbers">
          <div className="impact-stat">
            <h4>5,000+</h4>
            <p>Children Educated</p>
          </div>
          <div className="impact-stat">
            <h4>10,000+</h4>
            <p>Medical Consultations</p>
          </div>
          <div className="impact-stat">
            <h4>3,000+</h4>
            <p>Women Empowered</p>
          </div>
          <div className="impact-stat">
            <h4>50+</h4>
            <p>Villages Transformed</p>
          </div>
        </div>

        <div className="testimonials">
          <h3>Success Stories</h3>
          <div className="testimonial-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <img src={testimonial.image} alt={testimonial.name} />
                <p>"{testimonial.quote}"</p>
                <h4>{testimonial.name}</h4>
                <span>{testimonial.role}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;